import * as React from 'react';
import {connect} from "react-redux";
import {Role} from "../../models/Role";
import {ApplicationState} from "../../store";
import {RoleList} from '../components/RoleList';
import {ColumnData} from '../../models/ColumnData';
import {Button} from "@material-ui/core";
import {Tab, TabTypes} from "../Tab";
import {TabsService} from "../TabsService";
import AddIcon from "@material-ui/icons/AddCircleOutlineRounded";
import {actionRoleFetchAll, actionRoleDelete, actionDeleteRoles} from '../../store/roles/actions';
import {t} from "../../core/localization";
import PermissionContainer from "../../core/auth/PermissionContainer";
import {Permissions} from "../../core/auth/Permissions"

export interface RolesTabProps {
	roles: Role[]
	tab: Tab
}

export interface RolesTabState {
}

function mapStateToProps(state: ApplicationState) {
	return {
		roles: state.roles.list,
		tab: state.tabs.active
	};
}

class RolesTab extends React.Component<RolesTabProps, RolesTabState> {

	constructor(props: RolesTabProps) {
		super(props)
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps: RolesTabProps) {
	}

	componentDidMount() {
		actionRoleFetchAll()
	}

	onOpenClick(role: Role){
		TabsService.createTab(t.Role + ': ' + role.name, TabTypes.ROLES_NEW, role)
	}

	onCopyClick(role: Role){
		TabsService.createTab(t.Role + ': ' + role.name, TabTypes.ROLES_NEW, { ...role, id: null })
	}

	onDeleteClick(role: Role){
		actionRoleDelete(role);
	}

	onActionDeleteClick(roles: Role[]){
		actionDeleteRoles(roles);
	}

	onNewClick() {
		TabsService.createTab(t.NewRole, TabTypes.ROLES_NEW, new Role())
	}

	render(): React.ReactNode {

		const {roles} = this.props;

		const columns = [
			new ColumnData(t.Role, "name"),
		];

		return (
			<div style={{padding: '10px'}}>
				<PermissionContainer hasPermission={Permissions.ROLES_EDIT}>
					<div style={{marginBottom: '10px'}}><Button onClick={this.onNewClick} color="primary" style={{}}><AddIcon />{t.CreateNewRole}</Button></div>
				</PermissionContainer>
				<RoleList
					columns={columns}
					items={roles}
					title={t.Roles}
					onOpenClick={(role: Role) => this.onOpenClick(role)}
					onCopyClick={(role: Role) => this.onCopyClick(role)}
					onDeleteClick={(role: Role) => this.onDeleteClick(role)}
					onActionDeleteClick={(roles: Role[]) => this.onActionDeleteClick(roles)}
					tab={this.props.tab}
				/>
			</div>
		);
	}
}

export default connect(mapStateToProps)(RolesTab);
